import React, {useEffect, useState} from "react";
import { Icon, UserAvatar } from "../../../../components/Component";
import { Dropdown, DropdownMenu, DropdownToggle, Modal } from "reactstrap";
import { LinkItem, LinkList } from "../../../../components/links/Links";
import Toast from "../../../../utils/Toast";
import { findUpper } from "../../../../utils/Utils";
import axios from "axios";
import UpdateLicenceModal from "./UpdateLicenceModal";
import { useNavigate, Link } from "react-router-dom";
// import {toast as toastify} from "react-toastify/dist/core/toast";
import {Slide, toast as toastify, ToastContainer} from "react-toastify";
import Paho from "paho-mqtt";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const User = ({setHasNotifications, setHasUnreadNotifications}) => {
  const [open, setOpen] = useState(false);
  const [showUpdateLicenceModal, setShowUpdateLicenceModal] = useState(false);
  const navigate = useNavigate();

  const toggle = () => setOpen((prevState) => !prevState);

  const baseUrl = localStorage.getItem("API_URL");
  const token = localStorage.getItem("user_token");
  const userDetails = JSON.parse(localStorage.getItem("user_details"));

  let client = null;
  let configs = JSON.parse(localStorage.getItem("configuration_data"));


  const mqttIp = configs !== null ? configs['ip'] : '';
  const mqttPort = configs !== null ? configs['port'] : '';
  const mqttUsername = configs !== null ? configs['mq-username'] : '';
  const mqttPassword = configs !== null ? configs['mq-password'] : '';
  const ssl = configs !== null ? configs['use-ssl'] === 'true' : false;


  const [noOfNotifications, setNoOfNotifications] = useState([]);
  const [fourNotifications, setFourNotifications] = useState([]);

  const toggleUpdateLicenceModal = () => {
    setShowUpdateLicenceModal(!showUpdateLicenceModal);
  };
  useEffect(() => {
    if (token === null || userDetails === null) {
      navigate('/');
    }
    if (localStorage.getItem("configuration_data") === undefined)
      configurationData();
  }, [User]);

  // mqtt config - useEffect
  useEffect(() => {

    connect();
    return () => {
      if (client !== null && client.isConnected()) {
        client.unsubscribe(`alert/notify/user/${userDetails.uid}`)
        client.disconnect();
        client = null;
      }
    }
  }, [User])
  useEffect(() => {
    if (token !== null && userDetails !== null) {
      getNotifications()
      getCount()
    }

    // returned function will be called on component unmount
    return () => {
      if (client !== null && client.isConnected()) {
        client.unsubscribe(`alert/notify/user/${userDetails.uid}`)
        client.unsubscribe(`alert/update/notification/user/${userDetails.uid}`)
        client.disconnect();
        client = null;
      }
    }
  }, [])

  const onConnect = () => {
    // Once a connection has been made, make a subscription and send a message.
    client.subscribe(`alert/notify/user/${userDetails.uid}`);
    client.subscribe(`alert/update/notification/user/${userDetails.uid}`);
  }

  // called when the client loses its connection (mqtt)
  const onConnectionLost = (responseObject) => {
    if (responseObject.errorCode !== 0) {
      // console.log("onConnectionLost:" + responseObject.errorMessage);
    }
  }

  // called when a message arrives (mqtt)
  const onMessageArrived = (message) => {
    console.log("onMessageArrived:" + message);
    executeFunctions(message.payloadString);
  }

  const CloseButton = () => {
    return (
        <span className="btn-trigger toast-close-button" role="button">
            <span className="fa fa-times"></span>
        </span>
    );
  };

  const toastMessageCall = (title, content, position, type) => {

    console.log("content_1:", content);

    if (content === undefined) {
      console.log("content:", content);
    }

    return toastify.warning(`${content}`, {
      position: "top-right",
      autoClose: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: false,
      closeButton: <CloseButton />,
    });
  }

  // navigate to notification manager
  const navigateToNotificationManager = () => {
    navigate('/notification-manager')
  }

  const connect = () => {
    // client = new Paho.Client('103.1.179.245', Number(9005), 'mqttjs_' + Math.random().toString(16).substr(2, 8));
    client = new Paho.Client(mqttIp, Number(mqttPort), 'mqttjs_' + Math.random().toString(16).substr(2, 8));

    // set callback handlers (mqtt)
    client.onConnectionLost = onConnectionLost;
    client.onMessageArrived = onMessageArrived;
    client.connect({
      onSuccess: onConnect,
      userName: mqttUsername,
      password: mqttPassword,
      reconnect: true,
      useSSL: ssl
    });
  }

  const configurationData = () => {
    axios({
      method: 'POST',
      url: `${baseUrl}/branch/get-configs`,
      headers: {
        Authorization: localStorage.getItem("user_token")
      },
      data: {
        response: [
          "mq-password", "mqtt", "web-socket", "mq-username", "ip", "port", "use-ssl"
        ]
      }

    }).then((res) => {
      let data = res.data.data;
      localStorage.setItem('configuration_data', JSON.stringify(data));
      configs = data;
      //connect();
    }).catch((error) => {
      console.log(error);

      if (error.response.status === 401) {
        navigate('/');
        toast.remove();
        toast.error('Unauthorized', {
          position: 'bottom-center',
        });
        return;
      }
    })
  }


  // scroll progress bar
  const [scrolled, setScrolled] = useState(0);

  const scrollProgress = () => {
    const scrollPx = document.documentElement.scrollTop;
    const winHeightPx =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
    const scrolleda = `${scrollPx / winHeightPx * 100}%`;
    setScrolled(scrolleda)
  };
  window.addEventListener("scroll", scrollProgress);

  const progressContainerStyle = {
    background: "#f8bbd0",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
    height: "2px",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    zIndex: 99
  };

  const progressBarStyle = {
    width: scrolled
  };


  // get notification - function
  const getNotifications = () => {
    axios({
      method: 'GET',
      url: `${baseUrl}/alert/notification/get-list/latest/user/${userDetails.uid}`,
      headers: {
        Authorization: token
      }
    }).then((res) => {

      let data = res.data.data;
      if (data.length > 0) {
        setHasNotifications(true);
        const hasUnread = data.some((notification) => !notification.readStatus);
        setHasUnreadNotifications(hasUnread);
      }

      console.log("notification data: ", data)
      setFourNotifications(data);

    }).catch((error) => {
      console.log(error);

      // if (error.response.status === 401) {
      //   navigate('/');
      //   toast.remove();
      //   toast.error('Unauthorized', {
      //     position: 'bottom-center',
      //   });
      //   return;
      // }

      if (error.response !== undefined) {
        toast.remove();
        toast.error(error.response.data.message, {
          position: 'bottom-center',
        });
      } else {
        toast.remove();
        toast.error('Something went wrong', {
          position: 'bottom-center',
        });
      }
    })
  }

  // get notification count - functionn
  const getCount = () => {
    axios({
      method: 'GET',
      url: `${baseUrl}/alert/notification/get-count/unread/user/${userDetails.uid}`,
      headers: {
        Authorization: token
      }
    }).then((res) => {
      let count = res.data.data;
      setNoOfNotifications(count.unreadCount);
    }).catch((error) => {
      console.log(error);
      if (error.response !== undefined) {

        toast.error(error.response.data.message, {
          position: 'bottom-center',
        });
      } else {

        toast.error('Something went wrong', {
          position: 'bottom-center',
        });
      }
    })
  }

  // user logout - function
  const userLogOut = (e) => {
    e.preventDefault();

    Swal.fire({
      position: 'center',
      icon: 'question',
      text: 'Do you want to Logout?',
      showConfirmButton: true,
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
      width: '400px',

    }).then((result) => {
      if (result.value === true) {
        axios({
          method: 'POST',
          url: `${baseUrl}/user/logout`,
          headers: {
            Authorization: token
          },
          data: {
            "userId": userDetails.uid,
            "operatorLoginId": userDetails.operatorLoginId,
          }

        })
            .then(response => {

              toast.remove();
              toast.success('User Successfully Logout!',
                  {
                    position: 'bottom-center',
                  });
              localStorage.removeItem('user_token')
              localStorage.removeItem('user_details')

              navigate('/');

            }).catch((error) => {
          console.log(error);
          if (error.response !== undefined) {
            toast.remove();
            toast.error(error.response.data.message, {
              position: 'bottom-center',
            });
          } else {
            toast.remove();
            toast.error('Something went wrong', {
              position: 'bottom-center',
            })
          }
        })
      }
    })


  };

  const executeFunctions = (messageData) => {
    let message = JSON.parse(messageData);
    console.log("message:", messageData);
    if (messageData !== '5' && userDetails.userType === 4) {
      toastMessageCall(`${message.title}`, `${message.content}`, "top-right", 'dark')
    }
    getNotifications()
    getCount()
  }

  // user logout - function
  const handleSignout = () => {
    axios({
      method: "POST",
      url: `${baseUrl}/user/logout`,
      headers: {
        Authorization: token,
      },
      data: {
        userId: userDetails?.userId,
        operatorLoginId: userDetails?.operatorLoginId,
      },
    })
      .then((res) => {
        localStorage.removeItem("user_token");
        localStorage.removeItem("user_details");
        Toast("close");
        Toast("success", "Successfully logged out");
        window.location = "/";
      })
      .catch((error) => {
        console.log(error);

        if (error.response !== undefined) {
          Toast("close");
          Toast("error", error.response.data.message);
        } else {
          Toast("close");
          Toast("error", "Something went wrong");
        }
        window.location = "/";
      });
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <ToastContainer />
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar
            className="sm logged-user-avatar"
            text={findUpper(`${userDetails?.userFirstName}`)}
            image={userDetails?.image}
          />
          <div className="user-info d-none d-md-block">
            <div className="user-name dropdown-indicator">
              {userDetails?.userFirstName}
            </div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            {/* <div className="user-avatar">
              <span>AB</span>
            </div> */}
            <UserAvatar
              className="sm logged-user-avatar"
              text={findUpper(`${userDetails?.userFirstName} ${userDetails?.userLastName}`)}
              image={userDetails?.image}
            />
            <div className="user-info">
              <span className="lead-text">
                {userDetails?.userFirstName} {userDetails?.userLastName}
              </span>
              <div className="user-status">{userDetails?.userName}</div>
            </div>
          </div>
        </div>

        {/* User Profile Functionalities */}
        <div className="dropdown-inner">
          <LinkList>
            <LinkItem  icon="user-alt" onClick={toggle}>
              <Link to={`/user-profile?uid=${userDetails?.uid}`}>
                View Profile
              </Link>
            </LinkItem>
            {/* <LinkItem link="/user-profile-setting" icon="setting-alt" onClick={toggle}>
              Account Setting
            </LinkItem> */}
            {/*<LinkItem link={`/user-profile-activity/${userDetails?.userId}`} icon="activity-alt" onClick={toggle}>*/}
            {/*  Edit Company*/}
            {/*</LinkItem>*/}
            <LinkItem icon="award"
                      // onClick={toggleUpdateLicenceModal}
            >
              <Link to={`/licence`}>
                License
              </Link>
            </LinkItem>
          </LinkList>
        </div>

        <div className="dropdown-inner">
          <LinkList>
            <a onClick={(e) => userLogOut(e)}>
              <Icon name="signout"></Icon>
              <span>Sign Out</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>

      <Modal isOpen={showUpdateLicenceModal} size="lg" toggle={toggleUpdateLicenceModal}>
        <UpdateLicenceModal toggle={toggleUpdateLicenceModal} />
      </Modal>
    </Dropdown>
  );
};

export default User;
